function initializeShop(root = document) {
  root.querySelectorAll('[data-catalog-sort]').forEach(select => {
    if (select.dataset.initialized) return;
    select.dataset.initialized = 'true';
    select.addEventListener('change', () => {
      const url = new URL(location.pathname === '/' ? select.dataset.collectionUrl : location.pathname, location.origin);
      url.searchParams.set('sort_by', select.value);
      location.assign(url);
    });
  });
  root.querySelectorAll('[data-product-section]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
    const variantSelect = section.querySelector('[data-variant-select]');
    const options = [...section.querySelectorAll('[data-product-option]')];
    if (variantSelect) variantSelect.hidden = true;
    const image = section.querySelector('[data-product-image]');
    const button = section.querySelector('[data-add-to-cart]');
    options.forEach(option => option.addEventListener('change', () => {
      const chosen = options.map(input => input.value);
      const variant = variants.find(item => item.options.every((value, index) => value === chosen[index]));
      button.disabled = !variant?.available;
      button.textContent = !variant ? 'Unavailable' : variant.available ? 'Add to cart' : 'Sold out';
      section.querySelector('[data-product-status]').textContent = !variant ? 'This combination is unavailable.' : '';
      if (!variant) return;
      variantSelect.value = String(variant.id);
      section.querySelector('[data-product-price]').innerHTML = variant.price;
      const sku = section.querySelector('[data-product-sku]');
      if (sku) sku.textContent = variant.sku || '';
      if (variant.image && image) image.src = variant.image;
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }));
    section.querySelectorAll('[data-gallery-image]').forEach(thumbnail => thumbnail.addEventListener('click', () => {
      image.src = thumbnail.dataset.galleryImage;
      image.alt = thumbnail.dataset.galleryAlt;
    }));
  });
}
initializeShop();
document.addEventListener('shopify:section:load', event => initializeShop(event.target));
